import type { RouteLocationRaw } from "vue-router";
import type { AgentUiCommand } from "@/agent/types";

/**
 * Build the concrete route required before a page-owned capability executes.
 * This function only navigates; it never claims that the page operation
 * succeeded.  Success receipts must come from the mounted page component.
 */
export function locationForPageCommand(command: AgentUiCommand): RouteLocationRaw | null {
  const params = command.params || {};
  if (command.type === "archive.openBuilding" || command.type === "archive.openPhotos") {
    const buildingId = text(command.target) || text(params.buildingId);
    if (!buildingId) return null;
    const section = command.type === "archive.openPhotos" ? "photos" : text(params.section);
    const query: Record<string, string> = { from: "agent" };
    if (section) query.section = section;
    if (command.type === "archive.openPhotos") {
      query.openPhoto = params.openFirstOldPhoto === false ? "0" : "1";
    }
    return { name: "building-detail", params: { buildingId }, query };
  }
  if (command.type === "contribution.openDraft") {
    const query: Record<string, string> = {
      type: text(params.type) || "BUILDING_INFO"
    };
    const buildingId = text(command.target) || text(params.buildingId);
    if (buildingId) query.buildingId = buildingId;
    copyText(params, query, "buildingName", "section", "photoKind", "source", "gridId", "level");
    return { name: "crowdsource-submit", query };
  }
  if (command.type === "analysis.openMemoryGrid") {
    const path = text(params.path);
    if (path) return path;
    const gridId = text(params.gridId) || text(command.target);
    const level = text(params.level);
    if (!gridId || !level) return null;
    return { name: "memory-grid-insight", params: { level, gridId }, query: { from: "agent" } };
  }
  return null;
}

export function pageCommandMissingTargetMessage(command: AgentUiCommand): string {
  if (command.type.startsWith("archive.")) return "缺少要打开的建筑档案 ID";
  if (command.type === "analysis.openMemoryGrid") return "缺少要打开的记忆网格级别或编号";
  return "页面命令缺少必要目标";
}

function copyText(source: Record<string, unknown>, target: Record<string, string>, ...keys: string[]): void {
  for (const key of keys) {
    const value = text(source[key]);
    if (value) target[key] = value;
  }
}

function text(value: unknown): string {
  return typeof value === "string" ? value.trim() : value == null ? "" : String(value).trim();
}
